var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocateIconBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8346 7.91732C15.8346 12.6673 9.5013 17.4173 9.5013 17.4173C9.5013 17.4173 3.16797 12.6673 3.16797 7.91732C3.16797 6.23761 3.83523 4.62671 5.02296 3.43897C6.21069 2.25124 7.8216 1.58398 9.5013 1.58398C11.181 1.58398 12.7919 2.25124 13.9796 3.43897C15.1674 4.62671 15.8346 6.23761 15.8346 7.91732Z",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50131 10.2923C10.813 10.2923 11.8763 9.22899 11.8763 7.91732C11.8763 6.60564 10.813 5.54232 9.50131 5.54232C8.18964 5.54232 7.12631 6.60564 7.12631 7.91732C7.12631 9.22899 8.18964 10.2923 9.50131 10.2923Z",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocateIconBlack);
export default __webpack_public_path__ + "static/media/LocateIconBlack.aebaa7b4fc73e6f7fc92ed7e845b2be6.svg";
export { ForwardRef as ReactComponent };